import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Switch,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AirConfigModal from "../components/AirConfigModal";
import LanguageModal from "../components/LanguageModal";
import Title from "../components/PageTitle";
import { useToast } from "../components/Toast";
import apiService from "../Services/api.service";
const AirSettings = () => {
  const location = useLocation();
  const { kioskId } = location.state || {};
  const [isLoader, setIsLoader] = useState(false);
  const token = localStorage.getItem("token");
  const toast = useToast();
  const [selectedKiosk, setSelectedKiosk] = useState(null);
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
  const [isPrintDialogOpen, setIsPrintDialogOpen] = useState(false);
  const [isAirConfigOpen, setIsAirConfigOpen] = useState(false);
  const [printerEmail, setPrinterEmail] = useState("");
  const [settings, setSettings] = useState({
    bypassOtp: false,
    bypasslogin: false,
    enable_whatsapp_report: false,
    enable_appointment_booking: false,
    enable_print_report: false,
  });
  const fetchDetails = async () => {
    try {
      setIsLoader(true);
      const details = await apiService.fetchkioskDetails(kioskId, token);
      setSelectedKiosk(details.kiosk);
      setSettings({
        bypassOtp: details.kiosk.bypassOtp,
        bypasslogin: details.kiosk.bypasslogin,
        enable_whatsapp_report: details.kiosk.enable_whatsapp_report,
        enable_appointment_booking: details.kiosk.enable_appointment_booking,
        enable_print_report: details.kiosk.enable_print_report || false,
      });

      setPrinterEmail(details.kiosk.printer_email || "");
      setIsLoader(false);
    } catch (error) {
      console.error("Error fetching kiosk details:", error);
    } finally {
      setIsLoader(false);
    }
  };
  useEffect(() => {
    fetchDetails();
  }, [kioskId, token]);

  const openLanguageModal = () => {
    if (selectedKiosk) {
      setIsLanguageModalOpen(true);
    }
  };

  const openPrintDialog = () => {
    setIsPrintDialogOpen(true);
  };

  const handleToggle = (key) => {
    setSettings((prev) => {
      const newValue = !prev[key];
      const updated = { ...prev, [key]: newValue };

      if (key === "bypasslogin" && newValue) {
        updated["bypassOtp"] = false;
      }

      if (key === "bypassOtp" && newValue && prev["bypasslogin"]) {
        return prev;
      }

      handleSave(key, newValue);
      return updated;
    });
  };

  const handleSave = (key, value) => {
    const payload = {
      _id: kioskId,
      [key]: value,
    };

    if (key === "enable_print_report") {
      if (value === false) {
        setPrinterEmail("");
        payload["printer_email"] = "";
      } else {
        payload["printer_email"] = printerEmail.trim();
      }
    } 

    try {
      fetch(`${process.env.REACT_APP_API_HOST_URL}/ops/v1/kiosks/update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
    } catch (e) {
      console.log("Error", e);
    }
  };

  const handlePrintDialogSave = () => {
    if (settings.enable_print_report && !printerEmail.trim()) {
      toast.error("Please enter a printer email.");
      return;
    }
    if (!settings.enable_print_report) {
      handleSave("enable_print_report", settings.enable_print_report);
    } else {
      handleSave("enable_print_report", settings.enable_print_report);
    }

    setIsPrintDialogOpen(false);
  };

  const listItems = [
    { label: "Bypass OTP", key: "bypassOtp", type: "switch" },
    { label: "Token Mode", key: "bypasslogin", type: "switch" },
    { label: "WhatsApp Report", key: "enable_whatsapp_report", type: "switch" },
    {
      label: "Appointments",
      key: "enable_appointment_booking",
      type: "switch",
    },
    { label: "Print Report", type: "nav", action: openPrintDialog },
    { label: "air Languages", type: "nav", action: openLanguageModal },
    {
      label: "air Config",
      type: "nav",
      action: () => setIsAirConfigOpen(true),
    },
  ];

  return (
    <Paper sx={{ padding: 2, borderRadius: "12px" }}>
      <Title text="Air Settings" />
      <List>
        {listItems.map((item, index) => (
          <React.Fragment key={item.label}>
            <ListItem disableGutters sx={{ px: 1, alignItems: "flex-start" }}>
              <ListItemText primary={item.label} />
              <ListItemSecondaryAction>
                {item.type === "switch" ? (
                  <Switch
                    edge="end"
                    checked={settings[item.key]}
                    onChange={() => handleToggle(item.key)}
                    sx={{
                      "& .MuiSwitch-thumb": { color: "#fff" },
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#A020F0",
                      },
                      "& .MuiSwitch-track": { backgroundColor: "#D8BFD8" },
                    }}
                  />
                ) : (
                  <IconButton edge="end" onClick={item.action}>
                    <ArrowForwardIosIcon fontSize="small" />
                  </IconButton>
                )}
              </ListItemSecondaryAction>
            </ListItem>
            {index < listItems.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>

      {/* Language Modal */}
      {selectedKiosk && (
        <>
          <LanguageModal
            kiosk={selectedKiosk}
            isOpen={isLanguageModalOpen}
            onClose={() => setIsLanguageModalOpen(false)}
            onSave={async () => {
              await fetchDetails();
              setIsLanguageModalOpen(false);
            }}
          />

          <AirConfigModal
            kiosk={selectedKiosk}
            open={isAirConfigOpen}
            onClose={() => setIsAirConfigOpen(false)}
          />
        </>
      )}

      {/* Print Report Dialog */}
      <Dialog
        open={isPrintDialogOpen}
        onClose={() => setIsPrintDialogOpen(false)}
      >
        <DialogTitle>Print Report Settings</DialogTitle>
        <DialogContent>
          <List>
            <ListItem>
              <ListItemText primary="Enable Print Report" />
              <Switch
                edge="end"
                checked={settings.enable_print_report}
                onChange={() =>
                  setSettings((prev) => ({
                    ...prev,
                    enable_print_report: !prev.enable_print_report,
                  }))
                }
              />
            </ListItem>
            {settings.enable_print_report && (
              <ListItem>
                <TextField
                  fullWidth
                  label="Printer Email"
                  value={printerEmail}
                  onChange={(e) => setPrinterEmail(e.target.value)}
                  placeholder="Enter printer email"
                  variant="outlined"
                  size="small"
                />
              </ListItem>
            )}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsPrintDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handlePrintDialogSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default AirSettings;
